<template>
  <div :class="[containerClass]">
    <label v-if="label" :id="`input-${name}-label`" :for="`input${name}`" :class="[labelClass || 'form-label fs-6 fw-bolder text-black', {isRequired: 'required'}]">
      {{ label }} <span v-if="isRequired" class="text-danger"> * </span>
      <button v-if="info" style="padding: 0 !important; margin-left: 5px;" class="btn" data-bs-toggle="popover" data-bs-placement="top" :data-bs-content="$t(infoText)">
        <i class='fas fa-info-circle' style="font-size: 15px;"></i>
      </button>
    </label>
    <div class="m-0 p-0"  :class="[IsInputGroup ? 'input-group flex-nowrap' : '']">
      <div :class="{'overflow-hidden flex-grow-1': IsInputGroup}">
        <select :required="isRequired"
                :id="id"
                class="form-select kt_select2"
                :class="[{ 'invalid': (meta.touched && !meta.valid) }, getClasses(size), selectClass], { 'rounded-end-0': IsInputGroup }"
                :name="name"
                v-model="value"
                data-control="select2"
                :data-search="''+showSearch"
                :data-dropdown-parent="parentId ? parentId : ''"
                :multiple="multiple  ? 'multiple' : false"
                :disabled="isDisabled"
                :data-maximum-selection-length="maxSelection || null"
                :data-placeholder="placeholderText">
          <option></option>
          <slot />
        </select>
      </div>
      <span v-show="IsInputGroup" :id="`input-${name}-addon`" @click.prevent="clickAddon" class="input-group-text border-0 border-start-2">
        <i :class="getIcon(icon)"></i>
      </span>
    </div>
    <span class="text-danger" v-show="errorMessage"> {{ errorMessage }} </span>
  </div>
</template>

<script>
import {nextTick} from "vue";
import {useField} from "vee-validate";
export default {
  data() {
    const { handleChange, value, handleBlur, errorMessage, meta } = useField(() => this.name, undefined, {
      syncVModel: true,
    })
    return {
      handleChange,
      value,
      handleBlur,
      errorMessage,
      meta
    }
  },
  props: {
    name: { type: String, required: true },
    parentId: { type: String, default: '' },
    placeholderText: { type: String, default: '' },
    showSearch: { type: Boolean, default: true },
    multiple: { type: Boolean, required: true },
    // choix multiple limité (ex. 1 : recherche dans le champ comme une liste multiple, un seul choix)
    maxSelection: { type: Number, default: 0 },
    rules: String,
    labelClass: String,
    selectClass: String,
    containerClass: {
      type: String,
      default: 'col-12 mb-10'
    },
    label: String,
    isDisabled: Boolean,
    isRequired: Boolean,
    modelValue: String,
    iconText: String,
    IsInputGroup: Boolean,
    icon: String,
    iconDir: String,
    addonClass: String,
    clickAddon: Function,
    info: Boolean,
    infoText: String
  },
  computed: {
    id() {
      return `select-${this.name}-id`
    },
  },
  watch: {
    modelValue : function(value){
      if(value) {
        nextTick(() => {
          this.initSelect2()
        })
      }
    },
    id : function() {
      nextTick(() => {
        this.initSelect2()
      })
    },
    '$i18n.locale' : function(value) {
      if(value) {
        this.$nextTick(() => {
          this.initSelect2()
        })
      }
    },

  },
  mounted() {
    this.initSelect2()
  },
  updated() {
    this.$nextTick(() => {
      this.initSelect2()
    })
  },
  methods: {
    async initSelect2() {
      KTApp.initSelect2()
      const select =  $("#"+this.id)
      select.select2({
        minimumResultsForSearch: this.showSearch ? 2 : Infinity
      })
      select.select2().select2()
      if(this.multiple) {
        select.change((e) => {
          let result = [];
          if(e.target.value) {
            for (var i = 0, iLen = e.target.selectedOptions.length; i < iLen; i++) {
              if (e.target.selectedOptions[i].value != '' || e.target.selectedOptions[i].value != undefined) {
                result.push(e.target.selectedOptions[i].value);
              }
            }
          }
          this.$emit('update:modelValue', result);
        });
      } else {
        select.change((e) => {
          this.$emit('update:modelValue', e.target.value);
        });
      }
    },
    getIcon (icon) {
      return icon ? icon : null
    },
    hasIcon (icon) {
      return icon ? "input-group" : null
    },
    getClasses (size) {
      let sizeValue, isValidValue;

      sizeValue = size ? `form-control-${size}` : null;

      isValidValue = this.meta.touched && !this.meta.valid ? `invalid` : "valid";

      return `${sizeValue} ${isValidValue}`;
    }
  }

}
</script>
<style scoped>
.invalid {
  border: 1px solid red;
}
</style>
